import BasePriceBinder from './BasePriceBinder';

export default class FileBinder extends BasePriceBinder {
	constructor(id, title, calculator, summaryDisplayer, priceFormatter) {
		super(id, title, calculator, summaryDisplayer, priceFormatter);
		this.baseElement = document.getElementsByName(this.id + '[]')?.[0];
		this.isActive = this.baseElement.value !== '';
	}
	initEvents() {
		this.baseElement.addEventListener('change', (e) => {
			this.isActive = e.target.value !== '';
			this.handleChange();
		});

		super.initEvents();
	}
}
